import apiClient from "@repo/ui/lib/apiClient";

interface SSRPayload {
  ssrKey: string;
  count: number;
  note: string;
}

const getSSRsToSell = (allSSRKeys: string[], currencyCode: string) => {
  const ssrKeys: SSRPayload[] = [];

  for (const ssrKey of allSSRKeys) {
    ssrKeys.push({
      ssrKey,
      count: 1,
      note: "",
    });
  }

  return {
    keys: ssrKeys,
    currencyCode,
    feePricingMode: 0,
    forceWaveOnSell: false,
  };
};

export const sellSSRs = async (
  allSSRKeys: string[],
  currencyCode: string,
  tabSessionId?: string | null,
) => {
  const payload = getSSRsToSell(allSSRKeys, currencyCode);

  try {
    const response = await apiClient("/v1/ssr/booking", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: payload,
      withAuth: true,
      tabSessionId,
    });

    if (!response) {
      return {
        success: false,
        error: `API call failed: `,
      };
    }

    const data = response;

    return {
      success: true,
      data: data,
    };
  } catch (error) {
    const message = error instanceof Error ? error.message : "Unknown error";
    console.error("Sell SSrs API error:", message);

    return {
      success: false,
      error: `Network error: ${message}`,
    };
  }
};
